export const getMuxThumbnail = (playbackId: string) => `https://image.mux.com/${playbackId}/thumbnail.png`;

export const getMuxHlsPlayback = (playbackId: string) => {
  //`https://stream.mux.com/${playbackId}.m3u8`;
  return `${playbackId}`;
};
